import React, { useEffect, useState } from "react";
import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import { apiKey } from "../../../config/config";
import Select from "react-select";
import { toast } from "react-toastify";
import MessageCard from "../../../components/AdminCards/MessageCard";

function CSRSetup() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const [formData, setFormData] = useState({
    uid: "",
    serial_1: "",
    serial_2: "",
    serial_3: "",
    common_name: "",
    country: "SA",
    organization: "",
    org_unit: "",
    registered_address: "",
    invoice_type_simplified: false,
    invoice_type_standard: false,
    zatca_env: "SANDBOX",
    business_category: "",
    language: "en",
  });
  const [password, setPassword] = useState("");
  const [confirmSubmitModal, setConfirmSubmitModal] = useState(false);

  const environments = [
    {
      value: "SANDBOX",
      label: languageHelper("Sandbox"),
    },
    {
      value: "SIMULATION",
      label: languageHelper("Simulation"),
    },
    {
      value: "PRODUCTION",
      label: languageHelper("Production"),
    },
  ];

  const languages = [
    {
      value: "en",
      label: languageHelper("English"),
    },
    {
      value: "ar",
      label: languageHelper("Arabic"),
    },
  ];

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const submitData = () => {
    setLoading(true);
    axios
      .post(
        `${apiKey}/api/rms/admin/zatca/csr`,
        { ...formData, password },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.api_response || "CSR created successfully");
        setConfirmSubmitModal(false);
        setPassword("");
      })
      .catch((err) => {
        // handle error
        toast.error(err.response?.data?.message || "Failed to create CSR");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!firstTime) {
      setConfirmSubmitModal(true);
      return;
    }

    submitData();
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/zatca/csr`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        if (res.data.err_code === "data_not_found") {
          setFirstTime(true);
        } else {
          setFormData(res.data);
          setFirstTime(false);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || "Failed to fetch CSR data");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper("Zatca Configuration")}
          </h1>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="md:grid grid-cols-2 gap-x-4">
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("UID")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uid"
                    onChange={handleChange}
                    placeholder={languageHelper("UID")}
                    value={formData.uid}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Serial 1")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="serial_1"
                    onChange={handleChange}
                    placeholder={languageHelper("Serial 1")}
                    value={formData.serial_1}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Serial 2")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="serial_2"
                    onChange={handleChange}
                    placeholder={languageHelper("Serial 2")}
                    value={formData.serial_2}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Serial 3")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="serial_3"
                    onChange={handleChange}
                    placeholder={languageHelper("Serial 3")}
                    value={formData.serial_3}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Common Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="common_name"
                    onChange={handleChange}
                    placeholder={languageHelper("Common Name")}
                    value={formData.common_name}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Organization")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="organization"
                    onChange={handleChange}
                    placeholder={languageHelper("Organization")}
                    value={formData.organization}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Organizational Unit")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="org_unit"
                    onChange={handleChange}
                    placeholder={languageHelper("Organizational Unit")}
                    value={formData.org_unit}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Country")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="country"
                    onChange={handleChange}
                    placeholder={languageHelper("Country")}
                    value={formData.country}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Registered Address")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="registered_address"
                    onChange={handleChange}
                    placeholder={languageHelper("Registered Address")}
                    value={formData.registered_address}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Business Category")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="business_category"
                    onChange={handleChange}
                    placeholder={languageHelper("Business Category")}
                    value={formData.business_category}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Zatca Environment")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    options={environments}
                    defaultValue={{
                      value: formData.zatca_env,
                      label: environments.filter(
                        (item) => item.value === formData.zatca_env
                      )[0]?.label,
                    }}
                    onChange={(e) =>
                      setFormData({ ...formData, zatca_env: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Language")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    options={languages}
                    defaultValue={{
                      value: formData.language,
                      label: languages.filter(
                        (item) => item.value === formData.language
                      )[0]?.label,
                    }}
                    onChange={(e) =>
                      setFormData({ ...formData, language: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full flex gap-2 items-start">
                <input
                  id="b2c"
                  type="checkbox"
                  className="mt-1.5"
                  name="invoice_type_simplified"
                  checked={formData.invoice_type_simplified}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      invoice_type_simplified: e.target.checked,
                    })
                  }
                />
                <label htmlFor="b2c" className="flex flex-col text-sm">
                  <span className="text-d-bg-text">
                    {languageHelper("Simplified Invoice")}
                  </span>
                  <span className="text-gray-500 text-xs">
                    {languageHelper("For B2C / simplified e-invoices.")}
                  </span>
                </label>
              </label>
              <label htmlFor="" className="w-full flex gap-2 items-start">
                <input
                  id="b2b"
                  type="checkbox"
                  className="mt-1.5"
                  checked={formData.invoice_type_standard}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      invoice_type_standard: e.target.checked,
                    })
                  }
                  name="invoice_type_standard"
                />
                <label htmlFor="b2b" className="flex flex-col text-sm">
                  <span className="text-d-bg-text">
                    {languageHelper("Standard Invoice")}
                  </span>
                  <span className="text-gray-500 text-xs">
                    {languageHelper("For B2B / standard tax invoices.")}
                  </span>
                </label>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
                disabled={loading}
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Save Changes")}
              </button>
            </div>
          </form>
        </div>
      </div>
      {confirmSubmitModal && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 grid place-items-center z-50 backdrop-blur-sm"
          onClick={() => setConfirmSubmitModal(false)}
        >
          <div
            className="bg-white rounded p-6 w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                submitData();
              }}
            >
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Password")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="password"
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={languageHelper("Password")}
                    value={password}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <div className="flex justify-between mt-4">
                <button
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                  type="submit"
                  disabled={loading}
                >
                  {loading && (
                    <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                      <img
                        className="w-4 mx-auto"
                        src="/assets/gif/button_loader.gif"
                        alt=""
                      />
                    </span>
                  )}
                  {languageHelper("Submit")}
                </button>
                <button
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                  type="button"
                  onClick={() => setConfirmSubmitModal(false)}
                >
                  {languageHelper("Cancel")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  );
}

export default CSRSetup;
